/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from '../../common/constants';
export var PageContent = function PageContent() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(Image, null)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT + 100, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  left: "".concat(SECONDARY_NAV_WIDTH + 24, "px"),
  right: '34px',
  height: '80%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ImageWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center'
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 586,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 503,
    height: 20,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 6,
    x: 44,
    y: 60,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 6,
    x: 44,
    y: 48,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F5F01",
    d: "M32 60c0-8.837-7.163-16-16-16S0 51.163 0 60s7.163 16 16 16 16-7.163 16-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_782_7597)",
    d: "M16.02 71.548c1.972-.008 3.492-.817 4.583-2.112h.036a6.923 6.923 0 0 1-.576-.407c-.126-.092-.246-1.444-.328-2.765-1.083.886-2.23 1.245-2.839 1.713-.471.36-2.281.21-2.747-.23-.607-.571-1.21-1.13-1.75-1.708-.055 1.406-.154 2.942-.265 3.049 0 .003-.297.202-.642.41 1.088 1.26 2.59 2.042 4.528 2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F0C",
    d: "M20.703 69.436h-.1c-1.09 1.295-2.611 2.104-4.583 2.112-1.937-.008-3.44-.791-4.528-2.05l-.054-.062h-.1s-2.946 1.413-5.54 2.81a15.936 15.936 0 0 0 10.2 3.675c3.883 0 7.444-1.385 10.216-3.687A157.324 157.324 0 0 0 20.7 69.44l.003-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DAC6",
    d: "M22.4 59.739a18.416 18.416 0 0 1-.307 2.089c.02-.003.04-.01.061-.008a.262.262 0 0 1 .24.285.262.262 0 0 1-.283.24.256.256 0 0 1-.123-.046c-.03.133-.064.264-.097.392.389-.1.645-.436.688-1.03.06-.831.54-2.437.18-3.002-.09.366-.213.655-.346.878l-.013.2v.002ZM10.26 61.48a.262.262 0 0 1-.24-.285.262.262 0 0 1 .284-.24c.028 0 .054.013.08.023-.065-.676-.11-1.38-.1-1.907a2.372 2.372 0 0 1-.4-.85c-.125.72-.018 1.797-.074 2.416-.062.666.197 1.053.658 1.175-.013-.122-.028-.248-.041-.378a.255.255 0 0 1-.166.048v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253858",
    d: "M22.395 62.105a.264.264 0 0 0-.24-.285c-.021 0-.042.005-.062.008-.034.159-.067.317-.103.471a.255.255 0 0 0 .123.046.264.264 0 0 0 .285-.24h-.003ZM10.02 61.195a.264.264 0 0 0 .24.285.255.255 0 0 0 .167-.05l-.044-.455c-.025-.01-.05-.02-.079-.023a.264.264 0 0 0-.284.24v.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M14.15 67.747c.465.44 2.275.591 2.746.23.61-.468 1.759-.827 2.839-1.713a6.158 6.158 0 0 0 1.677-2.152c.174-.364.338-.863.481-1.419.033-.128.064-.258.097-.391.036-.157.072-.313.103-.471.148-.717.256-1.462.307-2.09l.013-.199c-.366.614-.799.758-.799.758s.085-.604.061-1.3c-.145-4.33-2.485-5.879-3.937-6.309-.916.433-2.322 1.503-2.309 4.02 0 0-2.527.45-4.001-.648a10.066 10.066 0 0 0-.627 2.06c-.133.684-.149 1.294-.149 1.294s-.176-.095-.371-.346c-.01.527.036 1.229.1 1.907l.043.456c.013.13.029.256.041.379.087.78.172 1.38.172 1.38.287 1.075.947 1.984 1.756 2.846.54.579 1.147 1.137 1.751 1.708h.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579DFF",
    d: "m17.403 49.281-.83-.066c-2.127-.115-6.218.542-6.786 7.605-.046.582.005 1.037.1 1.398.102.39.253.663.4.85.194.251.37.346.37.346s.013-.612.149-1.293a10.06 10.06 0 0 1 .627-2.06 2.467 2.467 0 0 1-.822-1.06s.958-5.835 7.224-4.862c.026 0 .167.61.297 1.203.126.563.241 1.109.241 1.109a3.912 3.912 0 0 0-.63.238c1.45.43 3.792 1.979 3.938 6.307.023.697-.062 1.301-.062 1.301s.435-.146.799-.758a3.25 3.25 0 0 0 .346-.878c.056-.23.102-.486.125-.783.568-7.066-3.364-8.369-5.484-8.594l-.002-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579DFF",
    d: "M18.13 51.342c-.13-.591-.271-1.2-.297-1.203C11.566 49.166 10.609 55 10.609 55c.092.23.212.43.353.607.138.174.297.325.468.453 1.475 1.1 4.002.648 4.002.648-.013-2.517 1.392-3.587 2.309-4.02.266-.125.494-.2.63-.238 0 0-.116-.547-.241-1.108Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 86,
    y: 100,
    fill: "#092957",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M16 116h24v24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85B8FF",
    d: "M28 138c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 2a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 659,
    height: 12,
    x: 66,
    y: 126,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 12,
    x: 66,
    y: 148,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 20,
    y: 218,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.5,
    height: 20,
    y: 254,
    fill: "#09326C",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M12.74 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.11c-.293.697-.908 1.087-1.708 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.6.964h.109v-.834h1.032v4.013c0 .478.28.759.772.759.862 0 1.416-1.087 1.416-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.86-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 21.5,
    y: 261,
    fill: "#596773",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.5,
    height: 20,
    x: 106.5,
    y: 254,
    fill: "#454F59",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M119.24 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.109c-.294.697-.909 1.087-1.709 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.599.964h.11v-.834h1.032v4.013c0 .478.28.759.773.759.861 0 1.415-1.087 1.415-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.859-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 128,
    y: 261,
    fill: "#596773",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.5,
    height: 20,
    x: 213,
    y: 254,
    fill: "#454F59",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M225.74 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.109c-.294.697-.909 1.087-1.709 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.599.964h.11v-.834h1.032v4.013c0 .478.28.759.773.759.861 0 1.415-1.087 1.415-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.859-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 234.5,
    y: 261,
    fill: "#596773",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 20,
    y: 306,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 12,
    y: 342,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 12,
    y: 370,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 12,
    y: 398,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 16,
    y: 436,
    fill: "#454F59",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85B8FF",
    d: "M18 436h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 442.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 36,
    y: 439,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 16,
    y: 468,
    fill: "#454F59",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85B8FF",
    d: "M18 468h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 474.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 36,
    y: 471,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 17,
    y: 501,
    stroke: "#596773",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 36,
    y: 503,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 17,
    y: 533,
    stroke: "#596773",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 36,
    y: 535,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 17,
    y: 565,
    stroke: "#596773",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 6,
    x: 36,
    y: 567,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_7597"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44 60h192v6H44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_782_7597"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 44h32v32H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_7597",
    x1: 16.064,
    x2: 16.064,
    y1: 77.595,
    y2: 63.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FCE1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5D6C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D1BB"
  }))));
};